export type State = {
  currentTab: number
  loadConfig: boolean
}

export const state: State = {
  currentTab: 0,
  loadConfig: false,
};
